import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ConvexAuthProvider } from '@convex-dev/auth/react'
import './i18n';
import App from './App.jsx'
import LandingRouter from './components/Landing/LandingRouter.jsx'
import convex from './convexClient.js'
import useAppStore from './stores/appStore'
import './styles/theme.css'
import './styles/components.css'
import './styles/rtl.css'

// Apply initial theme from persisted store
const initialTheme = useAppStore.getState().theme || 'dark';
document.documentElement.setAttribute('data-theme', initialTheme);

// Subscribe to theme changes - Zustand basic subscribe receives full state
useAppStore.subscribe((state) => {
    const theme = state.theme || 'dark';
    document.documentElement.setAttribute('data-theme', theme);
});

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <ConvexAuthProvider client={convex} storageNamespace="share-pen-auth">
            <BrowserRouter>
                <LandingRouter>
                    <App />
                </LandingRouter>
            </BrowserRouter>
        </ConvexAuthProvider>
    </React.StrictMode>,
)
